module.exports = __webpack_public_path__ + "static/badge_small-26747ce096cf4744f56d4db241f46c97.svg";